import $ from "jquery";

export default class PopUpFrame {
    constructor(config) {
        this.maxCountKey = "maxCount";
        this.viewCountKey = "pageViewCount";
        this.currentPageLinkKey = "PopUpFrameCurrentPage";
        this.cooldownExpirationKey = "cooldownExpiration";
        this.hideClass = "hide";
        this.maxViewCount = config.maxViewCount;
        this.frameUrl = PopUpFrame.getUrlWithoutQueryStrings(config.frameUrl);
        this.cooldownPeriod = config.cooldownPeriod;
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(config.cooldownPeriod) || config.cooldownPeriod < 1) {
            this.cooldownPeriod = 7;
        }

        $(".show-popup-btn").click(() => { this.showPopUpFrame(); });
        $(".popup-close-btn").click(() => { this.closePopUpFrame(); });
        $("#popUpFrame-bg").click(() => { this.closePopUpFrame(); });
        $(".popupFrame-okbutton").click(() => {
            this.showPopUpFrame();
            this.setCooldownExpiration();
            this.closePopUpFrameDialog();
        });
        $(".popupFrame-closebutton").click(() => {
            this.setCooldownExpiration();
            this.closePopUpFrameDialog();
        });
    }

    closePopUpFrame() {
        $("#popUpFrame").removeClass("popup-container").addClass(this.hideClass).attr("aria-hidden", true);
        $("#popUpFrame-bg").removeClass("popup-background").addClass(this.hideClass).attr("aria-hidden", true);
        $("#popUpFrame").remove();
        $("#popUpFrame-bg").remove();
    }

    showPopUpFrame() {
        $("#popUpFrame").addClass("popup-container").removeClass(this.hideClass).removeAttr("aria-hidden");
        $("#popUpFrame-bg").addClass("popup-background").removeClass(this.hideClass).removeAttr("aria-hidden");
        $(".popup-container").show();
        $(".popup-background").show();
    }

    closePopUpFrameDialog() {
        $("#popUpFrame-dialog").addClass(this.hideClass).attr("aria-hidden");
        this.setCooldownExpiration();
        this.setViewCount(0);
    }

    showPopUpFrameDialog() {
        $("#popUpFrame-dialog").addClass("popup-dialog").removeClass(this.hideClass).removeAttr("aria-hidden");
    }

    setMaxViewCount(value) {
        localStorage.setItem(this.maxCountKey, value);
    }

    getMaxViewCount() {
        return parseInt(localStorage.getItem(this.maxCountKey), 10);
    }

    getViewCount() {
        return parseInt(localStorage.getItem(this.viewCountKey), 10);
    }

    setViewCount(value) {
        localStorage.setItem(this.viewCountKey, value);
    }

    setCurrentTargetPage(value) {
        return localStorage.setItem(this.currentPageLinkKey, value);
    }

    getCurrentTargetPage() {
        return localStorage.getItem(this.currentPageLinkKey);
    }

    setCooldownExpiration() {
        const currentDate = new Date();
        const cooldownExpiration = new Date();
        cooldownExpiration.setDate(currentDate.getDate() + this.cooldownPeriod);
        return localStorage.setItem(this.cooldownExpirationKey, cooldownExpiration.getTime());
    }

    getCooldownExpiration() {
        return localStorage.getItem(this.cooldownExpirationKey);
    }

    hasCooldownExpired() {
        const cooldownExpiration = this.getCooldownExpiration();
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(cooldownExpiration)) {
            return false;
        }
        const currentDate = new Date();
        return currentDate.getTime() > new Date(Number(cooldownExpiration)).getTime();
    }

    static getUrlWithoutQueryStrings(url) {
        if (url.indexOf("?") > -1) {
            return url.substring(0, url.indexOf("?"));
        }

        return url;
    }

    Run() {
        if (!this.hasCooldownExpired()) return;

        // Check if page has changed - then reset counter
        const currentPage = this.getCurrentTargetPage();
        if (currentPage !== this.frameUrl) {
            this.setCurrentTargetPage(this.frameUrl);
            this.setViewCount(0);
        }

        // After how many times user has to browse before popupframe dialog will be shown
        let maxCount = parseInt(this.getMaxViewCount(), 10);
        if (maxCount !== this.maxViewCount) {
            this.setMaxViewCount(this.maxViewCount);
            this.setViewCount(0);
            maxCount = this.maxViewCount;
        }
        const viewCount = parseInt(this.getViewCount(), 10) + 1;
        if (maxCount > viewCount) {
            this.setViewCount(viewCount); // Increment view count
        } else {
            this.showPopUpFrameDialog();
            this.setViewCount(viewCount);
        }
    }
}
